export default __webpack_public_path__ + "static/media/EM1700.34I-39959_-23774_0.89cc7cdb.jpg";